const Login = require('./components/auth/Login').default;
const PasswordEmail = require('./components/auth/PasswordEmail').default;
const PasswordReset = require('./components/auth/PasswordReset').default;
const CompanyUsers = require('./components/main/company/Users').default;
const CreateCompany = require('./components/main/company/Create').default;
const ViewCompany = require('./components/main/company/View').default;
const Companies = require('./components/main/pages/Companies').default;
const Dashboard = require('./components/main/pages/Dashboard').default;
const Inventory = require('./components/main/pages/Inventory').default;
const Deal = require('./components/main/pages/Deals').default;
const Message = require('./components/main/pages/Message').default;

const Profile = require('./components/main/pages/Profile').default;
const Settings = require('./components/main/pages/Settings').default;
const User = require('./components/main/pages/Users').default;
const CreateUser = require('./components/main/user/Create').default;
const ViewUser = require('./components/main/user/View').default;
const Vehicle = require('./components/main/pages/Vehicles').default;
const VehicleShortlist = require('./components/main/pages/VehicleShortlist').default;
const CreateDeal = require('./components/main/deal/Create').default;

const CreateVehicle = require('./components/main/vehicle/Create').default;
const EditVehicle = require('./components/main/vehicle/Edit').default;
const ViewVehicle = require('./components/main/vehicle/View').default;

const ViewVehicleShare = require('@/components/main/share/Vehicle').default;

const CustomerEnquiry = require('@/components/main/pages/CustomerEnquiry').default;

export {
    Login,
    PasswordEmail,
    PasswordReset,
    Dashboard,
    Inventory,
    CompanyUsers,
    CreateCompany,
    CreateUser,
    ViewCompany,
    CreateDeal,
    Companies,
    Deal,
    Vehicle,
    VehicleShortlist,
    Message,
    Profile,
    Settings,
    User,
    ViewUser,
    CreateVehicle,
    EditVehicle,
    ViewVehicle,
    ViewVehicleShare,
    CustomerEnquiry,
}
